import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GetMissingInfoDetails, orderSummarySelector } from '../../../features/ordersSummary/orderSummarySlice';
import { Link } from 'react-router-dom';

const WaitingforInfo = ({fileID,MissingInfos}) => {

  return (
    <>
      <div
              className={"bg-gray-indicators h-[6.55px] mr-0.5 w-[17px]"}
              style={{ borderRadius: "2.34px" }}
            ></div>
            {" "}
            <div
              className={"bg-primary-yellow h-[6.55px] mr-0.5 w-[76.04px]"}
              style={{ borderRadius: "2.34px" }}
            ></div>{" "}
            <div
              className={"bg-gray-indicators h-[6.55px] mr-0.5 w-[17px]"}
              style={{ borderRadius: "2.34px" }}
            ></div>{" "}
            <div
              className={"bg-gray-indicators h-[6.55px] mr-0.5 w-[17px]"}
              style={{ borderRadius: "2.34px" }}
            ></div>{" "}

          <div
          className="statustooltip progressbar absolute bg-white h-auto p-4 right-[14px] rounded-sm w-[348px] z-10"
        >
          {" "}
          <div className="tip"></div>{" "}
          <div className="p-2 text-[12px] z-10 bg-white text-left">
            {" "}
            <h1 className="!font-semibold"> Documents missing: </h1>{" "}
            <ol className="list-decimal ml-4">
              {" "}
              {MissingInfos && MissingInfos?.length>0  && MissingInfos[0]!=="" && MissingInfos?.map((item, index) => {
                return (
                  <>
                    <li className="" key={index}> {item} </li>{" "}
                  </>
                );
              })}
            </ol>{" "}
            <button className="flex float-right mt-4 bg-white text-secondary-blue-link">
              {" "}
              <button className="mr-1"> 
                
              <Link
             to={`/ordersummary/${fileID}`}
          >
           Go to this order 
          </Link>
                </button>{" "}
              <svg width="20" height="20" fill="none">
                <path
                  d="m7.308 15.922 5.384-5.923-5.384-5.923"
                  stroke="#526D7D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>{" "}
            </button>{" "}
          </div>{" "}
        </div>{" "}
    </>
  )
}

export default WaitingforInfo
